import React, { useState } from 'react';
import { PipelineStage, Loan } from '../../types/dashboard';
import { ChevronRight, DollarSign, Clock } from 'lucide-react';
import { StageDetailModal } from './StageDetailModal';
interface PipelineFlowProps {
  stages: PipelineStage[];
  loans: Loan[];
}
export function PipelineFlow({
  stages,
  loans
}: PipelineFlowProps) {
  const [selectedStage, setSelectedStage] = useState<PipelineStage | null>(null);
  const getLoansForStage = (stageName: string) => {
    return loans.filter(loan => loan.stage === stageName);
  };
  const handleStageClick = (stage: PipelineStage) => {
    setSelectedStage(stage);
  };
  const handleCloseModal = () => {
    setSelectedStage(null);
  };
  return <>
      <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-6" data-id="element-135">
        <h3 className="font-bold text-slate-800 mb-6" data-id="element-136">Loan Pipeline Flow</h3>

        <div className="relative" data-id="element-137">
          {/* Connecting Line */}
          <div className="absolute top-1/2 left-0 w-full h-1 bg-slate-100 -translate-y-1/2 hidden md:block" data-id="element-138" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 relative" data-id="element-139">
            {stages.map((stage, index) => <div key={stage.name} className="relative group" data-id="element-140">
                {/* Node Circle */}
                <div className="w-4 h-4 rounded-full border-4 border-white shadow-sm absolute top-1/2 -translate-y-1/2 -left-2 hidden md:block z-10" style={{
              backgroundColor: stage.color
            }} data-id="element-141" />

                <button onClick={() => handleStageClick(stage)} className="w-full text-left bg-white p-4 rounded-lg border border-slate-200 shadow-sm hover:shadow-md hover:border-blue-300 transition-all relative z-0 cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2" data-id="element-142">
                  <div className="absolute top-0 left-0 w-1 h-full rounded-l-lg md:w-full md:h-1 md:rounded-t-lg md:rounded-bl-none" style={{
                backgroundColor: stage.color
              }} data-id="element-143" />

                  <div className="flex justify-between items-start mb-2 pl-2 md:pl-0 md:pt-2" data-id="element-144">
                    <h4 className="font-bold text-slate-700" data-id="element-145">{stage.name}</h4>
                    <span className="bg-slate-100 text-slate-600 px-2 py-0.5 rounded-full text-xs font-bold" data-id="element-146">
                      {stage.count}
                    </span>
                  </div>

                  <div className="space-y-2 pl-2 md:pl-0" data-id="element-147">
                    <div className="flex items-center text-slate-500 text-sm" data-id="element-148">
                      <DollarSign className="w-3 h-3 mr-1" data-id="element-149" />
                      {stage.value}
                    </div>
                    <div className="flex items-center text-slate-500 text-sm" data-id="element-150">
                      <Clock className="w-3 h-3 mr-1" data-id="element-151" />
                      Avg {stage.avgDays} days
                    </div>
                  </div>

                  <div className="mt-3 text-xs text-blue-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-152">
                    Click to view loans →
                  </div>
                </button>

                {index < stages.length - 1 && <div className="hidden md:block absolute top-1/2 -right-3 -translate-y-1/2 z-10 bg-white rounded-full p-0.5 text-slate-300" data-id="element-153">
                    <ChevronRight className="w-4 h-4" data-id="element-154" />
                  </div>}
              </div>)}
          </div>
        </div>
      </div>

      {selectedStage && <StageDetailModal isOpen={!!selectedStage} onClose={handleCloseModal} stageName={selectedStage.name} stageColor={selectedStage.color} loans={getLoansForStage(selectedStage.name)} data-id="element-155" />}
    </>;
}